import { ExternalLink } from "@octopusdeploy/design-system-components";
import { OverviewContainer, OverviewHighlightText } from "./CommonViews";
export const CommonProjectRunbookScheduledTriggersOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="ScheduledRunbookTriggers">Runbook triggers</ExternalLink> let you define a recurring schedule to automate execution of a runbook.
                </p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
